export default (function (o) {
  return o !== undefined && o !== null && typeof o.then === 'function';
});


// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@splitsoftware/splitio-react/es/splitio/utils/promise/thenable.js